import type {ScheduleCalendarRange} from '../domain/schedule-calendar';

/** Key segment for the calendar range the server picks itself (no bounds sent). */
const SERVER_DEFAULT_RANGE = 'default';

export const keys = {
  all: ['schedule'] as const,
  /** Prefix for every calendar range, so one invalidation refreshes all of them. */
  calendarAll: () => [...keys.all, 'calendar'] as const,
  calendar: (range: ScheduleCalendarRange | null) =>
    [
      ...keys.calendarAll(),
      range?.from ?? SERVER_DEFAULT_RANGE,
      range?.to ?? SERVER_DEFAULT_RANGE,
    ] as const,
  week: () => [...keys.all, 'week'] as const,
  templates: (q: string) => [...keys.all, 'templates', q] as const,
  activeWorkout: () => [...keys.all, 'active-workout'] as const,
  mutations: {
    saveWeek: () => [...keys.all, 'mutations', 'save-week'] as const,
    createOneOff: () => [...keys.all, 'mutations', 'create-one-off'] as const,
    removeOneOff: () => [...keys.all, 'mutations', 'remove-one-off'] as const,
    skipOccurrence: () => [...keys.all, 'mutations', 'skip-occurrence'] as const,
    restoreOccurrence: () => [...keys.all, 'mutations', 'restore-occurrence'] as const,
    moveOccurrence: () => [...keys.all, 'mutations', 'move-occurrence'] as const,
    swapOccurrence: () => [...keys.all, 'mutations', 'swap-occurrence'] as const,
    startOccurrence: () => [...keys.all, 'mutations', 'start-occurrence'] as const,
  },
} as const;
